export const headerInfo = {
    title: "Provider Experience Measurement",
    title2: "",
    link: {},
    subHeader: "BETA Version – Data Under Review",
    subTitle: "Displays a summary view of provider experience priorities like Provider Effort, Claims Yield, and Service Quality. Users can compare these trends over time to track UHC's provider experience performance.",
    subPemTitle: "Please note that while Contract Yield and Average Claim Processing Days data are stable, other data elements may be refined as we continue evaluating internal Effort Index, and Service Metrics."

};
export const effortIndex = "Effort Index";
export const averageClaimProcessingDays = "Average Claim Processing Days";
export const contractYield = "Contract Yield";
export const contractYieldSubHeaderText = "The yield displayed on this graph is directional only and uses estimated non-payment dollars.";
export const contractYieldFooterText = "MM/DD/YYYY - MM/DD/YYYY";
export const claimDetails = "Claims Details";
export const serviceMetrics = "Service Metrics";

type FilterOption = {
    value: string;
    title: string;
    disable?: boolean;
    default?: boolean;
};
export const LOB_OPTIONS: FilterOption[] = [
    { value: 'ALL', title: 'All Lines of Business', disable: false },
    { value: 'EI', title: 'Commercial', disable: false },
    { value: 'MR', title: 'Medicare', disable: false },
    { value: 'CS', title: 'Medicaid', disable: false },
    { value: 'EXC', title: 'Individual Exchange', disable: false },
];
export const REGION_OPTIONS: FilterOption[] = [
    { value: 'National', title: 'National', disable: true },
];
export const LOB = {
    LoB: {
        title: 'LoB',
        type: 'dropDown',
        selectedValue: { ...LOB_OPTIONS.find((obj) => obj?.value === 'ALL') },
        width: '230px',
        filterOptionsSize: 'large',
        filterType: 2,
        isSorted: true,
        filterDisplayKey: 'title',
        filterValueKey: 'value',
        filterKey: 'LoB',
        key: 'LoB',
        disabled: false,
        options: [...LOB_OPTIONS],
        activeFilter: true,
        filterDisable: true,
        dropDowndisabled: false,
    },
};

export const REGION = {
    Region: {
        title: 'Region',
        type: 'dropDown',
        selectedValue: { ...REGION_OPTIONS.find((obj) => obj?.value === 'National') },
        width: '230px',
        filterOptionsSize: 'large',
        filterType: 2,
        isSorted: true,
        filterDisplayKey: 'title',
        filterValueKey: 'value',
        filterKey: 'Region',
        key: 'Region',
        disabled: true,
        options: [],
        activeFilter: false,
        filterDisable: true,
        dropDowndisabled: false,
    },
};
export const DATE = "MM/DD/YYY";
export const TIME_PERIOD = {
    timePeriod: {
        title: 'Timeperiod',
        type: 'dropDown',
        selectedValue: { title: `${DATE} - ${DATE}`, value: `${DATE} - ${DATE}` },
        width: '257px',
        filterOptionsSize: 'large',
        filterType: 1,
        isSorted: false,
        filterDisplayKey: 'value',
        filterValueKey: 'value',
        filterKey: 'timePeriod',
        key: 'timePeriod',
        disabled: true,
        options: [],
        activeFilter: false,
        filterDisable: true,
    },
};

export const peiMetricData = {
    effortIndex: {title: "Effort Index", metricId:"2301"},
    averageClaimProcessingDays: {title: "Average Claim Processing Days", metricId:"2303"},
    contractYield: {title: "Contract Yield", metricId:"2302"}
}
export const defaultFilterData = { value: 'Total', title: 'Total' };
export const seriesColors = {
    received_to_processed_tat_days: '#003DA1',
    service_to_received_tat_days: '#3381FF',
    avg_received_to_processed_tat_days: '#003DA1',
    avg_service_to_received_tat_days: '#3381FF',
  };
export const tooltipLabels = {
    received_to_processed_tat_days: 'Received to Processed',
    service_to_received_tat_days: 'Date of Service to Received',
    avg_received_to_processed_tat_days: 'Received to Processed',
    avg_service_to_received_tat_days: 'Date of Service to Received',
  };
export const effortIndexOptions: any[] = [
    {
      value: 'Total', title: 'Total Effort Index', disable: false,
      nestedOptions: [
        { value: 'Contacts', title: 'Contacts', disable: false },
        { value: 'P2P', title: 'P2P', disable: false },
        { value: 'Medical Records', title: 'Medical Records', disable: false },
        { value: 'Reconsiderations', title: 'Reconsiderations', disable: false },
        { value: 'Appeals', title: 'Appeals', disable: false },
      ]
    }
  ];
export const radioOptions = ['Monthly', 'Annually']

export const appealFairness = {
    title: "Appeal Fairness Star Rating Uphold Rate",
    yearToDateValue: "94.4%",
    yearToDateValueCurrent: "44.4",
    yearToDateValuePrevious: "44.4",
    yeartoDatetitle: "Year to Date",
     currentYearTimePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    priorYearTimePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    loader: true,
    error: false,
    timePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    metricData:{title: "Appeal Fairness Star Rating Uphold Rate", metricId:"2304"},
    currentYearData: [
        {
            name: 'Series 1',
            color: '#007bff',
            values: [
                {
                    date: '2024-01-01', value: 90
                },
                {
                    date: '2024-02-01', value: 92
                },
                {
                    date: '2024-03-01', value: 89
                },
                {
                    date: '2024-04-01', value: 95
                },
                {
                    date: '2024-05-01', value: 97
                },
                {
                    date: '2024-06-01', value: 90
                },
                {
                    date: '2024-07-01', value: 95
                },
                {
                    date: '2024-08-01', value: 90
                },
                {
                    date: '2024-09-01', value: 99
                },
                {
                    date: '2024-10-01', value: 90
                },
                {
                    date: '2024-11-01', value: 92
                },
                {
                    date: '2024-12-01', value: 90
                },
            ],
        },],
    priorYearData: [
        {
            name: 'Series 2',
            color: '#007bff',
            values: [
                {
                    date: '2024-01-01', value: 20
                },
                {
                    date: '2024-02-01', value: 20
                },
                {
                    date: '2024-03-01', value: 20
                },
                {
                    date: '2024-04-01', value: 50
                },
                {
                    date: '2024-05-01', value: 30
                },
                {
                    date: '2024-06-01', value: 40
                },
                {
                    date: '2024-07-01', value: 50
                },
                {
                    date: '2024-08-01', value: 60
                },
                {
                    date: '2024-09-01', value: 80
                },
                {
                    date: '2024-10-01', value: 95
                },
                {
                    date: '2024-11-01', value: 80
                },
                {
                    date: '2024-12-01', value: 90
                },
            ],
        },]
};
export const postCallNPS = {
    title: "Post Call NPS",
    formate:"Number",
    yearToDateValue: "84.4",
    yearToDateValueCurrent: "44.4",
    yearToDateValuePrevious: "44.4",
    yeartoDatetitle: "Year to Date",
     currentYearTimePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    priorYearTimePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    loader: true,
    error: false,
    timePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    metricData:{title: "Post Calls NPS", metricId:"2305"},
    currentYearData: [
        {
            name: 'Series 1',
            color: '#007bff',
            values: [
                {
                    date: '2024-01-01', value: 80
                },
                {
                    date: '2024-02-01', value: 20
                },
                {
                    date: '2024-03-01', value: 50
                },
                {
                    date: '2024-04-01', value: 50
                },
                {
                    date: '2024-05-01', value: 30
                },
                {
                    date: '2024-06-01', value: 55
                },
                {
                    date: '2024-07-01', value: 70
                },
                {
                    date: '2024-08-01', value: 60
                },
                {
                    date: '2024-09-01', value: 80
                },
                {
                    date: '2024-10-01', value: 95
                },
                {
                    date: '2024-11-01', value: 60
                },
                {
                    date: '2024-12-01', value: 80
                },
            ],
        },],
    priorYearData: [
        {
            name: 'Series 2',
            color: '#007bff',
            values: [
                {
                    date: '2024-01-01', value: 20
                },
                {
                    date: '2024-02-01', value: 20
                },
                {
                    date: '2024-03-01', value: 20
                },
                {
                    date: '2024-04-01', value: 50
                },
                {
                    date: '2024-05-01', value: 30
                },
                {
                    date: '2024-06-01', value: 40
                },
                {
                    date: '2024-07-01', value: 50
                },
                {
                    date: '2024-08-01', value: 60
                },
                {
                    date: '2024-09-01', value: 80
                },
                {
                    date: '2024-10-01', value: 95
                },
                {
                    date: '2024-11-01', value: 80
                },
                {
                    date: '2024-12-01', value: 90
                },
            ],
        },]
};
export const secretStopper = {
    title: "Secret Shopper Data Accuracy (Form Level)",
    yearToDateValue: "44.4%",
    yearToDateValueCurrent: "44.4",
    yearToDateValuePrevious: "44.4",
    yeartoDatetitle: "Year to Date",
     currentYearTimePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    priorYearTimePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    loader: true,
    error: false,
    timePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    metricData:{title: "Secret Shopper Data Accuracy (Form Level)", metricId:"2307"},
    currentYearData: [
        {
            name: 'Series 1',
            color: '#007bff',
            values: [
                {
                    date: '2024-01-01', value: 80
                },
                {
                    date: '2024-02-01', value: 20
                },
                {
                    date: '2024-03-01', value: 50
                },
                {
                    date: '2024-04-01', value: 50
                },
                {
                    date: '2024-05-01', value: 30
                },
                {
                    date: '2024-06-01', value: 55
                },
                {
                    date: '2024-07-01', value: 70
                },
                {
                    date: '2024-08-01', value: 60
                },
                {
                    date: '2024-09-01', value: 80
                },
                {
                    date: '2024-10-01', value: 95
                },
                {
                    date: '2024-11-01', value: 60
                },
                {
                    date: '2024-12-01', value: 80
                },
            ],
        },],
    priorYearData: [
        {
            name: 'Series 2',
            color: '#007bff',
            values: [
                {
                    date: '2024-01-01', value: 20
                },
                {
                    date: '2024-02-01', value: 20
                },
                {
                    date: '2024-03-01', value: 20
                },
                {
                    date: '2024-04-01', value: 50
                },
                {
                    date: '2024-05-01', value: 30
                },
                {
                    date: '2024-06-01', value: 40
                },
                {
                    date: '2024-07-01', value: 50
                },
                {
                    date: '2024-08-01', value: 60
                },
                {
                    date: '2024-09-01', value: 80
                },
                {
                    date: '2024-10-01', value: 95
                },
                {
                    date: '2024-11-01', value: 80
                },
                {
                    date: '2024-12-01', value: 90
                },
            ],
        },]
};
export const digitalNPS = {
    title: "Digital NPS",
    formate:"Number",
    yearToDateValue: "44.4",
    yearToDateValueCurrent: "44.4",
    yearToDateValuePrevious: "44.4",
    yeartoDatetitle: "Year to Date",
     currentYearTimePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    priorYearTimePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    loader: true,
    error: false,
    timePeriod: "MM/DD/YYYY - MM/DD/YYYY",
    metricData:{title: "Digital NPS", metricId:"2306"},
    currentYearData: [
        {
            name: 'Series 1',
            color: '#007bff',
            values: [
                {
                    date: '2024-01-01', value: 80
                },
                {
                    date: '2024-02-01', value: 20
                },
                {
                    date: '2024-03-01', value: 50
                },
                {
                    date: '2024-04-01', value: 50
                },
                {
                    date: '2024-05-01', value: 30
                },
                {
                    date: '2024-06-01', value: 55
                },
                {
                    date: '2024-07-01', value: 70
                },
                {
                    date: '2024-08-01', value: 60
                },
                {
                    date: '2024-09-01', value: 80
                },
                {
                    date: '2024-10-01', value: 95
                },
                {
                    date: '2024-11-01', value: 60
                },
                {
                    date: '2024-12-01', value: 80
                },
            ],
        },],
    priorYearData: [
        {
            name: 'Series 2',
            color: '#007bff',
            values: [
                {
                    date: '2024-01-01', value: 20
                },
                {
                    date: '2024-02-01', value: 20
                },
                {
                    date: '2024-03-01', value: 20
                },
                {
                    date: '2024-04-01', value: 50
                },
                {
                    date: '2024-05-01', value: 30
                },
                {
                    date: '2024-06-01', value: 40
                },
                {
                    date: '2024-07-01', value: 50
                },
                {
                    date: '2024-08-01', value: 60
                },
                {
                    date: '2024-09-01', value: 80
                },
                {
                    date: '2024-10-01', value: 95
                },
                {
                    date: '2024-11-01', value: 80
                },
                {
                    date: '2024-12-01', value: 90
                },
            ],
        },]
};

